import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const ClientAccountHeader = ({ clientName, navTotal, ccy = 'ZAR', isLatest }) => {
  const formatCurrency = (value) => {
    if (!value && value !== 0) return 'R 0.00';

    return new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: '#121212', // ✅ forced dark mode
        border: '1px solid #2a2a2a',
        color: '#ffffff'
      }}>
      {/* CLIENT NAME */}
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
        {clientName?.toUpperCase()}
      </Typography>

      {/* BALANCE TYPE */}
      <Typography variant="body2" mt={0.5}>
        {isLatest ? 'Latest Balances' : 'Month End Balance'}
      </Typography>

      {/* spacing */}
      <Box sx={{ height: 2 }} />

      {/* ZAR DOMICILE */}
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          mt: 2
        }}>
        ZAR DOMICILE
      </Typography>

      {/* NAV TOTAL */}
      <Typography variant="h4" fontWeight={700} sx={{ fontSize: '32px', mt: 0.5 }}>
        {`${ccy} ${formatCurrency(navTotal)}`}
      </Typography>
    </Paper>
  );
};

export default ClientAccountHeader;
